import classNames from 'classnames';
import styles from './SkipToMain.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface SkipToMainProps {
	children: React.ReactNode;
	link?: string;
	title?: string;
}

export const UI_SkipToMain = ({ children, title, link }: SkipToMainProps) => (
	<UI_Link url={link} title={title} className={classNames(styles.SkipToMain)}>
		{children}
	</UI_Link>
);
